import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { Routes } from '@/routes';
import { Flex, LoadingSpin } from '@/components';
import { clearPreRegistrationPaymentContext } from '@/services/dormitoryStudent.service';
import { dormitoryStudentQueryKeys } from './dormitoryStudentQueryKeys';

/** Return URL after Rose pre-registration payment (`callBackAppUrl`). */
export function DormitoryPreRegisterPaymentCallback() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { message } = App.useApp();
  const [t] = useTranslation(['common', 'dormitory']);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      clearPreRegistrationPaymentContext();
      await queryClient.invalidateQueries({ queryKey: dormitoryStudentQueryKeys.all });
      if (cancelled) {
        return;
      }
      message.success(t('dormitory:messages.pre-register-payment-success'));
      navigate(Routes.DormitoryPreRegister, { replace: true });
    })();

    return () => {
      cancelled = true;
    };
  }, [message, navigate, queryClient, t]);

  return (
    <Flex align="center" justify="center" className="h-full min-h-[40vh] pb-20">
      <LoadingSpin />
    </Flex>
  );
}
